import { sanctioned_individual } from '@axo/shared/data-access/types';
import { useQuery } from 'react-query';
import { sanctionedIndividualKeys } from '../../cache-keys/sanctionedIndividualKeys';
import { useAPI } from '@axo/shared/data-access/provider';
import { sanctioned_individual_api } from '@axo/shared/data-access/api';

export function useSactions(
  request: sanctioned_individual.FindSactionsRequest,
  options: { enabled?: boolean } = {},
) {
  const api = useAPI();

  return useQuery({
    queryKey: [sanctionedIndividualKeys.find(request)],
    queryFn: ({ queryKey: [{ request }] }) =>
      sanctioned_individual_api.findSanctions(api)(request),
    enabled: api.token.length > 0 && options.enabled,
  });
}
